import { ENVIROMENT } from "../../../../../../v2-config/constants/enviroment.constant";

export const Config = {
	lengthName: 50,
};

export const constant = {
	defaultAddress: ENVIROMENT.APP_ADDRESS?.split(',')[0],
};